import React from "react";
import SignIn from "./SingIn";
import Grid2 from "@mui/material/Unstable_Grid2";
import { Card, CardActionArea, CardContent, CardMedia, Divider, Tooltip } from "@mui/material";
import { useAtomValue } from "jotai";
import { appConfig } from "../../atoms";
import { useNavigate } from "react-router-dom";
import SignInStyles from "./signin.module.css";
import clsx from "clsx";
import styles from "./signin.module.css";

const LkNavigateButton = () => {
  const navigate = useNavigate();

  const onCardClick = () => {
    navigate("/lk");
  };
  return (
    <Grid2
      container
      direction="row"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Card className={clsx(SignInStyles.cardSignInStyle)}>
        <CardActionArea onClick={onCardClick}>
          <CardMedia component="img" image="logo.png" sx={{ p: 2 }} />
          <CardContent sx={{ textAlign: "center" }}>Вход в Личный Кабинет</CardContent>
        </CardActionArea>
      </Card>
    </Grid2>
  );
};

const SignInWrapper = () => {
  const config = useAtomValue(appConfig);

  if (!config?.smeta?.signOptions?.splitSignIn) return <SignIn />;
  return (
    <Grid2
      container
      direction="row"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Grid2 item sx={{ width: "49.5%" }} className={clsx(styles.wrapperLkButtonContainer)}>
        <LkNavigateButton />
        <div className={clsx(styles.wrapperSmetaText)}>{config.smeta.signOptions.textAboutButtons?.lk}</div>
      </Grid2>
      <Grid2 item sx={{ height: "70%" }}>
        <Divider flexItem variant={"fullWidth"} orientation="vertical" sx={{ height: "100%" }} />
      </Grid2>
      <Grid2 item sx={{ width: "49.5%" }}>
        <SignIn />
      </Grid2>
    </Grid2>
  );
};

export default SignInWrapper;
